import {useCallback, useMemo} from "react";
import {useSelector} from "react-redux";

import AppService from "Services/AppService";

export default () => {

	const {org} = useSelector(store => store);

	/**
	 * Resolve a path via the active org's uploads directory root.
	 */
	const getOrgUploadPath = useCallback(path => {
		return AppService.getOrgUploadsPath(org?.Id, path);
	}, [org]);

	return useMemo(() => {
		return {
			getOrgUploadPath,
			org: (org?.Id ? org : null),
			orgLogoSrc: AppService.getRegistrationLogo()
		};
	}, [getOrgUploadPath, org]);

};
